export const byId = <T extends HTMLElement>(id: string): T | null => document.querySelector<T>(`#${id}`);

export const setTextContent = (element: HTMLElement | null, message: string): void => {
  if (!element) {
    return;
  }

  element.textContent = message;
};

export const setHidden = (element: HTMLElement | null, hidden: boolean): void => {
  if (!element) {
    return;
  }

  element.hidden = hidden;
};

export const setBadgeCount = (badge: HTMLElement | null, count: number): void => {
  if (!badge) {
    return;
  }

  badge.textContent = String(count);
  badge.hidden = count <= 0;
};
